<template>
  <div>
    <div class="p-lg-3">
      <div class="row justify-content-between">
        <h3 class="mt-0 mb-2 font-weight-bold text-left">
          Procedimento Especialidade
        </h3>
      </div>
    </div>

    <v-data-table
      v-on:update:sort-by="options.ordenacao = true"
      :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
      :search="search"
      :headers="headers"
      :items="procedimentoEspecialidadeList"
      :options.sync="options"
      :server-items-length="totalList"
      class="elevation-1"
      :loading="loading"
      :loading-text="'Carregando...'"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- DIALOG DE CADASTRO -->
          <v-dialog persistent v-model="dialogCadastrar" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="allowCadastrarBtn"
                color="#1daf80"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                Novo Procedimento Especialidade
              </v-btn>
            </template>
            <modal-cadastro
              @response="atualizarProcedimentoEspecialidadePosCadastro"
              @close="closeDialogCadastrar"
            />
          </v-dialog>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <!-- DIALOG DE EXCLUSÃO-->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline" style="word-break: normal"
                >Tem certeza de que deseja excluir este Especialidade?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1daf80" text @click="closeDelete"
                  >Cancelar</v-btn
                >
                <v-btn
                  :loading="loadingDelete"
                  class="btn-danger"
                  text
                  style="color: #fff !important"
                  @click="deleteItemConfirm"
                  >Deletar</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          />
          <!-- DIALOG DE EDIÇÃO -->
          <v-dialog
            persistent
            max-width="500px"
            v-if="dialogEdicao"
            v-model="dialogEdicao"
          >
            <modal-edicao
              v-if="dialogEdicao"
              :procedimentoEspecialidade="editedProcedimentoEspecialidade"
              @close="closeDialogEdited"
              @response="atualizarProcedimentoEspecialidadePosEdicao($event)"
            />
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          v-if="allowEditarBtn"
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:no-data>
        <p class="text-center">Nenhum registro encontrado</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import modalCadastro from "@/components/setor/modal_cadastro";
import modalEdicao from "@/components/procedimento_especialidade/modal_edicao";
import modalCadastro from "@/components/procedimento_especialidade/modal_cadastro";
import ProcedimentoEspecialidadeService from "../services/procedimento_especialidade_service.js";
import Mixin from "@/mixins/vuex_snackbar_mixin.js";
// import endpoints from "@/router/endpoints";
import AuthService from "@/services/auth_service";

export default {
  mixins: [Mixin],
  components: {
    modalCadastro,
    modalEdicao,
  },
  data: () => ({
    dialogCadastrar: false,
    dialogEdicao: false,
    dialogDelete: false,
    dialog: false,
    dialogObs: false,
    editedProcedimentoEspecialidade: {},
    idToDeleted: 0,
    search: "",
    totalList: 10,
    options: {
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      order: false,
      desc: false,
    },
    dialogCadastro: false,
    procedimentoEspecialidadeList: [],
    headers: [
      {
        text: "Procedimento",
        align: "start",
        sortable: true,
        value: "procedimentoDescricao",
      },
      {
        text: "Especialidade",
        align: "start",
        sortable: true,
        value: "especialidadeDescricao",
      },
      { text: "Ações", align: "end", value: "actions", sortable: false },
    ],
    loading: false,
    loadingDelete: false,
    services: {
      procedimentoEspecialidade: ProcedimentoEspecialidadeService.build(),
      authService: AuthService.build(),
    },
  }),

  watch: {
    dialog(val) {
      val || this.closeDialogCadastrar();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    search() {
      if (this.search.length > 2) {
        this.atualizarProcedimentoEspecialidadeList();
      }
    },
    options: {
      handler() {
        this.options.desc = this.options.sortDesc[0] ?? false;
        this.atualizarProcedimentoEspecialidadeList();
      },
      deep: true,
    },
  },

  mounted() {
    // this.atualizarProcedimentoEspecialidadeList();
  },
  computed: {
    allowCadastrarBtn() {
      return true; //this.services.authService.temPermissao(endpoints["SetorController::POST->registerSetor"]);
    },
    allowEditarBtn() {
      return true;
      // return this.services.authService.temPermissao(endpoints["ProcedimentoEspecialidadeController::POST->updateProcedimentoEspecialidade/$1"]);
    },
  },
  methods: {
    atualizarProcedimentoEspecialidadePosCadastro() {
      this.$_ACTIONS_showSnackbarMessage({
        message: "O Especialidade foi cadastrado com sucesso.",
        color: "sucess",
      });
      this.atualizarProcedimentoEspecialidadeList();
      this.closeDialogCadastrar();
    },
    atualizarProcedimentoEspecialidadePosEdicao() {
      this.dialogEdicao = false;
      this.atualizarProcedimentoEspecialidadeList();
    },
    async atualizarProcedimentoEspecialidadeList() {
      this.loading = true;
      await this.services.procedimentoEspecialidade
        .getProcedimentoEspecialidadePaginatedList({
          page: this.options.page,
          per_page: this.options.itemsPerPage,
          sort: this.options.order,
          desc: this.options.desc,
          search: this.search,
          filter: {},
        })
        .then(async (response) => {
          if (response.status !== 200) return;
          const { data } = await response.json();
          const { pagination, especialidade_procedimentos } = data;
          this.totalList = pagination.num_rows;
          this.procedimentoEspecialidadeList = especialidade_procedimentos.map(
            ({
              id,
              descricao_procedimento,
              descricao_especialidade,
              id_especialidade,
              id_procedimento,
              id_tipo_procedimento,
            }) => {
              return {
                id: parseInt(id),
                procedimentoDescricao: descricao_procedimento,
                especialidadeDescricao: descricao_especialidade,
                especialidadeId: parseInt(id_especialidade),
                procedimentoId: parseInt(id_procedimento),
                tipoProcedimentoId: parseInt(id_tipo_procedimento),
              };
            }
          );
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editItem(item) {
      this.editedProcedimentoEspecialidade = item;
      this.dialogEdicao = true;
    },

    deleteItem({ id }) {
      this.idToDeleted = id;
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.loadingDelete = true;
      this.services.procedimentoEspecialidade
        .deletar(this.idToDeleted)
        .then(async ({ status }) => {
          this.$_ACTIONS_showSnackbarMessage({
            message:
              status === 200
                ? "O Prodecidimento Especialidade foi deletado com sucesso."
                : this.$global.messages.internalServerError,
            color: status === 200 ? "sucess" : "error",
          });
          status === 200 &&
            (await this.atualizarProcedimentoEspecialidadeList());
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.loadingDelete = false;
          this.closeDelete();
        });
    },

    closeDialogCadastrar() {
      this.dialogCadastrar = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDialogEdited() {
      this.dialogEdicao = false;
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>
